const initHelpers = ()=> {

    const initCopyLink = () => {
        const copyLinkBtn = document.querySelector('[data-copy-link]');
        if(copyLinkBtn) {
            copyLinkBtn.addEventListener('click', function(e) {
                e.preventDefault();

                copyLinkBtn.classList.add('copied');

                const url = window.location.href;
                const tempInput = document.createElement("input");

                document.body.appendChild(tempInput);
                tempInput.setAttribute("value", url);
                tempInput.select();
                document.execCommand("copy");
                document.body.removeChild(tempInput);

                // textContainer.innerHTML = copiedText;
                setTimeout(() => {
                    copyLinkBtn.classList.remove('copied');
                }, 2000);
            });
        }
    }
    const makeTablesResponsive = () => {
        const sectionContentElms = document.querySelectorAll('.section__content');
        sectionContentElms.forEach((sectionContent) => {
            const tables = sectionContent.querySelectorAll('table');
            tables.forEach((table) => {
                // console.log('table', table)
                if (!table.classList.contains('table__info')) {
                    const tableWrapper = document.createElement('div');
                    tableWrapper.classList.add('table__responsive');
                    table.parentNode.insertBefore(tableWrapper, table);
                    tableWrapper.appendChild(table);
                }
            });
        });
    }
    const initProgressBar = () => {
        const progressElm = document.querySelector('.progressbar')
        const progressValue = document.querySelector('.progressbar_value')

        function recalculateProgress() {

            const viewportHeight = window.innerHeight
            const pageHeight = document.body.offsetHeight
            const footerHeight = document.querySelector('.footer').offsetHeight
            const currentPosition = window.scrollY

            // console.log('viewportHeight', viewportHeight)
            // console.log('pageHeight', pageHeight)
            // console.log('footerHeight', footerHeight)
            // console.log('currentPosition', currentPosition)

            let availableHeight = pageHeight - footerHeight - viewportHeight

            let percent = 0;

            availableHeight <= 0 ? percent = 100 : percent = (currentPosition / availableHeight) * 100

            // console.log('availableHeight', availableHeight)
            // console.log('percent', percent)
            if (percent <= 100) {
                progressElm.querySelector('span').style.height = percent + '%'
                progressValue.innerHTML = Math.round(percent) + '%'
            } else {
                progressElm.querySelector('span').style.height = '100%'
                progressValue.innerHTML = '100%'
            }
        }

        window.addEventListener('scroll', recalculateProgress)
        window.addEventListener('resize', recalculateProgress)

        recalculateProgress();
    }
    const initShowMore = () => {

        const showMoreBtn = document.querySelectorAll('[data-show-more]')

        showMoreBtn.forEach(btn => {

            console.log('showMoreBtn', btn.dataset.defaultText);

            const showMoreBtnDefaultText = btn.dataset.defaultText;
            const showMoreBtnActiveText = btn.dataset.activeText;

            btn.addEventListener('click', function(e) {
                e.preventDefault();

                const parentContainer = btn.closest('.popular__countries');
                const hiddenItems = parentContainer.querySelectorAll('[data-hidden]');

                hiddenItems.forEach(item => {
                    if (item.classList.contains('hidden')) {
                        item.classList.remove('hidden');
                        btn.querySelector('span').textContent = showMoreBtnActiveText;
                    } else {
                        item.classList.add('hidden');
                        btn.querySelector('span').textContent = showMoreBtnDefaultText;
                    }
                });

            });
        });

    }
    const initDescriptionToggle = () => {

        const descriptionElms = document.querySelectorAll('.description__block');

        descriptionElms.forEach((item) => {
            const descriptionTriggerElm = item.querySelector('[data-description-trigger]');

            if (descriptionTriggerElm) {
                descriptionTriggerElm.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    const defaultText = descriptionTriggerElm.dataset.default;
                    const activeText = descriptionTriggerElm.dataset.active;

                    if (item.classList.contains('show')) {
                        descriptionTriggerElm.innerHTML = defaultText;
                        item.classList.remove('show');
                    } else {
                        descriptionTriggerElm.innerHTML = activeText;
                        item.classList.add('show');
                    }
                });
            }
        });
    }

    return {
        initCopyLink,
        makeTablesResponsive,
        initProgressBar,
        initShowMore,
        initDescriptionToggle,
    }

}

export default initHelpers;
